<template>
  <div :class="['steps-bar', labelHorizontal ? 'label-horizontal' : 'label-vertical']">
    <div v-for="step in steps" :key="step.label"
      :class="['sc-step', {
          'step-done': step.done,
          'step-active': currentStep === step.step
        }
      ]"
      @click="$emit('step-clicked', step)"
    >
      <template v-if="!labelHorizontal">
        <div class="step-inner">
          <div class="step-circle" :class="[{'clickable': clickable}]">
            <font-awesome-icon v-if="step.icon" :icon="step.icon" size="lg" fixed-width />
          </div>
          <div class="step-label">{{ step.label }}</div>
        </div>
      </template>

      <template v-else>
        <div class="step-circle">
          <font-awesome-icon v-if="step.icon" :icon="step.icon" size="lg" fixed-width />
        </div>
        <div class="step-label">{{ step.label }}</div>
      </template>

      <div v-if="step.step < steps.length - 1" class="step-line">
        <div class="step-line-fill"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Breadcrumbs',
  props: {
    currentStep: {
      type: Number,
      required: true
    },
    steps: {
      type: Array,
      required: true,
      default: () => []
    },
    labelHorizontal: {
      type: Boolean,
      default: true
    },
    clickable: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
    }
  }
}
</script>

<style scoped>
  .steps-bar {
    --aa-blue: #1d58b7;
    --bs-green: #29A745;
  }


  .steps-bar {
    display: flex;
    align-items: flex-start;
    flex-wrap: wrap;
    padding: 4px 28px 12px;
    margin: 20px auto;
  }

  .label-vertical .step-inner {
    display: flex;
    flex-direction: column;
    align-items: center;
    flex-shrink: 0;
  }

  .label-vertical .step-label {
    margin-top: 6px;
    margin-left: 0;
  }

  .label-vertical .step-line {
    min-width: 20px;
    align-self: flex-start;
    margin-top: 15px;
  }

  .label-horizontal .step-label {
    margin-left: 8px;
  }

  .sc-step {
    display: flex;
    align-items: center;
    flex: 1;
    margin-top: 10px;
    cursor: default;
  }
  .sc-step:last-child { flex: 0 0 auto; }
  .step-circle {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    border: 2px solid #ddd;
    background: #fff;
    color: #bbb;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.8rem;
    font-weight: 700;
    transition: all 0.2s;
    flex-shrink: 0;
    z-index: 1;
    box-shadow: 0 0 0 4px rgba(73, 73, 72, 0.15);
  }
  .step-active .step-circle {
    border-color: var(--aa-blue);
    background: var(--aa-blue);
    color: #fff;
    box-shadow: 0 0 0 4px rgba(56, 92, 175, 0.427);
  }
  .step-done .step-circle {
    border-color: var(--bs-green);
    background: var(--bs-green);
    color: #fff;
    box-shadow: 0 0 0 4px  rgba(72, 169, 103, 0.372);
  }
  .step-pending .step-circle {
    border-color: #DC3645;
    background: #DC3645;
    color: #fff;
    box-shadow: 0 0 0 4px  rgba(207, 41, 41, 0.372);
  }

  .step-label { font-size: 1rem; font-weight: 600; color: #bbb; white-space: nowrap; margin-left: 8px; transition: color 0.2s; }
  .step-active .step-label { color: var(--aa-blue); }
  .step-done .step-label { color: var(--bs-green); }
  .step-pending .step-label {
    color: #DC3645;
    cursor: pointer;
  }

  .step-line { flex: 1; height: 2px; background: #e5e3dc; margin: 0 12px; border-radius: 2px; position: relative; overflow: hidden; }
  .step-done .step-line-fill { position: absolute; top: 0; left: 0; bottom: 0; width: 0; background: var(--bs-green); transition: width 0.35s ease; }
  .step-done .step-line-fill { width: 100%; }

  @media (max-width: 767px) {
    .step-label { font-size: 0.7rem; }
    .step-line { height: 1px; margin: 0 6px; }
    .step-circle { width: 24px; height: 24px; font-size: 0.7rem; }

    .steps-bar { padding: 12px 16px 10px; }
  }

</style>
